import PropTypes from 'prop-types';
import { Stack, TextField, Typography, Button, Autocomplete } from '@material-ui/core';
import { RemoveCircleOutline } from '@material-ui/icons';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved

CollectionSingleRuleForm.propTypes = {
  data: PropTypes.object,
  handleDeleteRule: PropTypes.func,
  setRule: PropTypes.func,
  rules: PropTypes.array,
  errors: PropTypes.object,
  id: PropTypes.number
};

export default function CollectionSingleRuleForm({ id, data, handleDeleteRule, setRule, rules, errors }) {
  const { exclusionColumnOption } = useSelector((state) => state.collection);
  const handleValueChange = (id, index, val) => {
    const tempRule = [...rules];
    tempRule[id] = {
      ...tempRule[id],
      [index]: val
    };
    setRule(tempRule);
  };

  const conditionOptions = [
    'Contain',
    'Not Contain',
    'Greater than',
    'Less than',
    'Equals',
    'Not equals to',
    'Is Empty',
    'Not Empty'
  ];

  return (
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent="flex-end">
        {data.id !== 0 && (
          <Typography
            variant="subtitle1"
            sx={{ width: '90%', display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: '14px' }}
          >
            {' '}
            OR Condition{' '}
          </Typography>
        )}
        <Button
          variant="text"
          startIcon={<RemoveCircleOutline />}
          onClick={() => {
            handleDeleteRule(data.id);
          }}
          title="Delete Rule"
        />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 1 }}>
        {/* <TextField
          fullWidth
          label="Column"
          placeholder="Column"
          value={rules[id].column_name}
          onChange={(e) => handleValueChange(id, 'column_name', e.target.value)}
          error={Boolean(errors?.rules && errors?.rules[id]?.column_name)}
          helperText={errors?.rules && errors?.rules[id]?.column_name}
        /> */}
        <Autocomplete
          fullWidth
          options={exclusionColumnOption}
          getOptionLabel={(option) => option}
          value={rules[id].column_name}
          onChange={(e, value) => {
            handleValueChange(id, 'column_name', value);
          }}
          // renderInput={(params) => <TextField {...params} label="Cell" margin="none" />}

          renderInput={(params) => (
            <TextField
              error={Boolean(errors?.rules && errors?.rules[id]?.column_name)}
              helperText={errors?.rules && errors?.rules[id]?.column_name}
              required
              {...params}
              label="Column"
              margin="none"
            />
          )}
        />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
        <Autocomplete
          fullWidth
          options={conditionOptions}
          getOptionLabel={(option) => option}
          value={rules[id].if_cell_value}
          onChange={(e, value) => {
            handleValueChange(id, 'if_cell_value', value);
          }}
          // renderInput={(params) => <TextField {...params} label="Cell" margin="none" />}

          renderInput={(params) => (
            <TextField
              error={Boolean(errors?.rules && errors?.rules[id]?.if_cell_value)}
              helperText={errors?.rules && errors?.rules[id]?.if_cell_value}
              required
              {...params}
              label="Type"
              margin="none"
            />
          )}
        />
        {/* <TextField
          fullWidth
          label="Cell"
          placeholder="Cell"
          value={rules[id].if_cell_value}
          onChange={(e) => handleValueChange(id, 'if_cell_value', e.target.value)}
          error={Boolean(errors?.rules && errors?.rules[id]?.if_cell_value)}
          helperText={errors?.rules && errors?.rules[id]?.if_cell_value}
        /> */}
        <TextField
          sx={{ width: '70%' }}
          placeholder="Enter Value"
          value={rules[id].value_or_text}
          onChange={(e) => handleValueChange(id, 'value_or_text', e.target.value)}
          error={Boolean(errors?.rules && errors?.rules[id]?.value_or_text)}
          helperText={errors?.rules && errors?.rules[id]?.value_or_text}
        />
      </Stack>
    </Stack>
  );
}
